import { render, staticRenderFns } from "./ControlNotification.vue?vue&type=template&id=c6cab7ac&scoped=true"
import script from "./ControlNotification.vue?vue&type=script&lang=js"
export * from "./ControlNotification.vue?vue&type=script&lang=js"
import style0 from "./ControlNotification.vue?vue&type=style&index=0&id=c6cab7ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6cab7ac",
  null
  
)

export default component.exports